import React from "react";
import AuthorImg1 from "../../../assets/images/authorImg1.png";
import { useApi } from "../../../hooks/useApi";
import { API_ENDPOINTS } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import ErrorMsg from "../../../components/ErrorMsg/ErrorMsg";
import { useAuth } from "../../../context/AuthContext";
import styles from "./AuthorMembers.module.css";


export default function AuthorMembers() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_AUTHOR_MEMBERS_SPOTLIGHT
  );
  const apiData = response?.authorMembersSpotlight;
  const navigate = useNavigate();
  const { setAuthModal, userdata } = useAuth();

  const handleBecomeMember = () => {
    if (userdata) {
      // User is logged in, redirect to appropriate dashboard
      if (userdata.role === 'institution') {
        navigate('/dashboard/institution');
      } else {
        navigate(`/dashboard/${userdata.role}`);
      }
    } else {
      // User is not logged in, open signup popup
      setAuthModal({ open: true, tab: "signup" });
    }
  };
  return (
    <section className={styles.authors}>
      <div className={styles.container}>
        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            apiData.slice(0, 3).map((t) => (
            <article className={styles.card} key={t.id}>
                <div className={styles.userDetails}>
                  <figure>
                    <img src={t.author.photograph} alt={t.author.full_name} />
                  </figure>
                  <div className={styles.content}>
                    <h6>{t.author.full_name}</h6>
                    <p title={`${t.author.current_designation} |  ${t.author.departmentFacultyName} | ${t.author.institution_name}, ${t.author.city}`}>
                      {t.author.current_designation} |  {t.author.departmentFacultyName} | {t.author.institution_name}, {t.author.city}
                    </p>

                  </div>
                </div>
                {/* <ul className={styles.tagContainer}>
                  {t.tags && t.tags.map((i) => <li key={i}>{i}</li>)}
                </ul> */}
                <div className={styles.details}>
                  {t.author.profileSummary?.length > 88
                    ? `${t.author.profileSummary.substring(0, 88)}...`
                    : t.author.profileSummary}
                </div>
                <div className={styles.tagOuter}>
                  <button
                    onClick={() => navigate(`/authors/${t.author.user_id}`)}
                  >
                    View Profile 
                  </button>
                </div>
              </article>
            ))
          )}
        </div>
        <button onClick={handleBecomeMember} className={styles.becomeMentor}>Become a Author</button>
      </div>
    </section>
  );
}
